// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:42:50

export default {
  "id": "ragdoll-show-throw-break-and-destroy",
  "slug": "ragdoll-show-throw-break-and-destroy",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/c0434ba028de40e1878244a8b2b6ffab-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/c0434ba028de40e1878244a8b2b6ffab/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Ragdoll Show: Throw, Break and Destroy!",
      "description": "Dive into the chaotic fun of ragdoll mayhem! Navigate thrilling challenges by guiding your ragdoll character through each level, leveraging realistic physics for epic destruction. Sharpen your skills and unleash maximum chaos—can you conquer every challenge and emerge victorious?",
      "instructions": "Drag the character onto different objects and watch the chaos unfold.\nExperiment with various objects and angles to maximize the damage.\nGet ready to throw, break, and destroy the ragdoll!",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "challenge",
        "destroy",
        "physics",
        "ragdoll"
      ]
    },
    "zh-CN": {
      "title": "拉格doll秀：抛、砸、毁！",
      "description": "深入混乱的ragdoll狂欢！通过引导你的ragdoll角色通过每个关卡，利用逼真的物理效果进行史诗般的破坏。磨练你的技巧，释放最大混乱——你能征服每一个挑战并取得胜利吗？",
      "instructions": "将角色拖拽到不同的物体上，观看混乱展开。\n尝试各种物体和角度以最大化伤害。\n准备抛掷、打碎和摧毁这个布娃娃！",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "挑战",
        "摧毁",
        "物理",
        "布娃娃"
      ]
    },
    "zh-TW": {
      "title": "拉格多秀：丟、破、毀！",
      "description": "投入 Ragdoll 混亂之樂的狂亂中！通過引導你的 Ragdoll 角色通過每個關卡，利用真實物理來實現經典毀滅。鍛鍊你的技能並釋放最大亂亂——你能征服每一個挑戰並獲勝出來嗎？",
      "instructions": "將角色拖放到不同的物體上，觀察混亂展開。\n嘗試各種物體和角度以 maximise 淩傷。\n準備好丟擲、破碎和摧毀布娃娃吧！",
      "genres": [
        "休闲",
        "謎題"
      ],
      "tags": [
        "挑戰",
        "摧毀",
        "物理",
        "Ragdoll"
      ]
    },
    "zh-HK": {
      "title": "拉格doll Show: 投、破、毀！",
      "description": "投進 Ragdoll 混亂的樂趣！透過引導你的 Ragdoll 角色通過每一關，利用真實的物理學帶來壯觀的毀滅。鍛鍊你的技巧，釋放極限混亂—你能征服每一個挑戰並獲得勝利嗎？",
      "instructions": "將角色拖放到不同的物體上，觀賞混亂展開。\n嘗試不同的物體和角度，以 maximise 淀粉質損害。\n準備好拋、碎裂和摧毀這個布娃娃！",
      "genres": [
        "輕鬆",
        "謎題"
      ],
      "tags": [
        "挑戰",
        "摧毀",
        "物理",
        "搖桿娃娃"
      ]
    },
    "ja": {
      "title": "ラグドールショー：投げて、割って、壊して！",
      "description": "ラグドールの混乱の楽しみに飛び込みましょう！リアルな物理演算を駆使して、各レベルを通してラグドールキャラクターを導きながら、興奮に満ちた挑戦に挑みます。スキルを鍛え、最大の混乱を引き起こし、すべての挑戦を克服して勝利できるかどうか挑戦してみてください！",
      "instructions": "キャラクターを様々なオブジェクトにドラッグして混乱が展開するのを見てください。\n様々なオブジェクトと角度を試しながらダメージを最大化しましょう。\nボール投げ、壊し、破壊するラグドールに備えてください！",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "挑戦",
        "破壊",
        "物理",
        "ラグドール"
      ]
    },
    "ko": {
      "title": "라그도ール 쇼: 던져, 깨고, 파괴하라!",
      "description": "장난감 인형 혼란의 혼란스러운 재미에 뛰어들어보세요! 각 레벨을 통해 장난감 인형 캐릭터를 이끌며 흥미진진한 도전을 완료하여, epic destruction을 위한 실제 물리를 활용하세요. 기술을 가다듬고 최대 혼란을 일으킬 수 있을까요? 모든 도전을 통과하고 승리할 수 있을까요?",
      "instructions": "캐릭터를 다양한 물체에 드래그하여 혼란을 관찰하세요.\n여러 물체와 각도를 실험하여 데미지를 극대화하세요.\n똥칸을 던지고, 깨고, 파괴할 준비 되셨나요!",
      "genres": [
        "캐주얼",
        "퍼즐"
      ],
      "tags": [
        "챌린지",
        "파괴",
        "물리학",
        "랜고봇"
      ]
    },
    "fr": {
      "title": "Ragdoll Show : Lâche, casse et détruis !",
      "description": "Plongez dans le fun débridé des ragdoll en folie ! Parcourez des défis palpitants en guidant votre personnage ragdoll à travers chaque niveau, en exploitant la physique réaliste pour des destructions épiques. Affûtez vos compétences et déclenchez le chaos à son maximum — pouvez-vous conquérir chaque défi et triompher ?",
      "instructions": "Tirez le personnage sur différents objets et regardez le chaos s'ensuivre.\nExpérimentez avec divers objets et angles pour maximiser les dégâts.\nPréparez-vous à jeter, briser et détruire le ragdoll !",
      "genres": [
        "Facile",
        "Puzzle"
      ],
      "tags": [
        "défis",
        "détruire",
        "physique",
        "ragdoll"
      ]
    }
  }
};
